import types from "../types";

export function registerDepartment(values) {
  return async (dispatch) => {
    return dispatch({
      type: types.REGISTER,
      payload: {
        request: {
          url: "department/register",
          method: "POST",
          data: values,
        },
      },
    });
  };
}

export function getOptions() {
  return async (dispatch) => {
    return dispatch({
      type: types.GET_OPTIONS,
      payload: {
        request: {
          url: "department/",
          method: "GET",
        },
      },
    });
  };
}

export function getSubOptions() {
  return async (dispatch) => {
    return dispatch({
      type: types.GET_SUB_OPTIONS,
      payload: {
        request: {
          url: "department/sub",
          method: "GET",
        },
      },
    });
  };
}
